import React from "react";

const Purchased = () => {
  return <div>Purchased</div>;
};

export default Purchased;
